import React from 'react'
import { Box } from 'grommet'

import Avatar from './Avatar'
import Bubble from './Bubble'
import Day from './Day'

import { isSameUser, isSameDay } from './utils'

const Message = ({
  position = 'left',
  currentMessage = {},
  user = {},
  ...props
}) => {
  const getInnerComponentProps = () => {
    return {
      ...props,
      position,
      currentMessage,
      user,
      isSameUser,
      isSameDay
    }
  }
  const renderDay = () => {
    if (currentMessage.createdAt) {
      const dayProps = getInnerComponentProps()
      if (props.renderDay) {
        return props.renderDay(dayProps)
      }
      return <Day {...dayProps} />
    }
    return null
  }

  const renderBubble = () => {
    const bubbleProps = getInnerComponentProps()
    if (props.renderBubble) {
      return props.renderBubble(bubbleProps)
    }

    return <Bubble {...bubbleProps} />
  }

  const renderAvatar = () => {
    if (user._id !== currentMessage.user?._id) {
      const avatarProps = getInnerComponentProps()
      return <Avatar {...avatarProps} />
    }
    return null
  }

  return (
    <Box>
      {renderDay()}
      <Box
        style={{
          marginBottom: 2
        }}>
        {position === 'left' ? renderAvatar() : null}
        {renderBubble()}
        {position === 'right' ? renderAvatar() : null}
      </Box>
    </Box>
  )
}

export default Message
